import React from 'react';
import styled from 'styled-components';
import { warmGrey, breakpoints, fontWeight, divisionColors, fontFamily, notificationColors, acurisGlobalColors, colors } from '@mergermarket/acuris-react-styles';
import { TextSectionHeader } from '@mergermarket/acuris-react-section-header';
import FocusContext from '@mergermarket/acuris-react-focus-context';
import { UserIcon } from '@mergermarket/acuris-react-icon';

const StyledContactsList = styled.ul`
  list-style-type: none;
  margin: 0 1.2rem;
  padding: 0;

  & li {
    border-bottom: 1px solid ${warmGrey.IV};
    padding: 0.8rem 0;

    &:last-child {
      border-bottom: 0;
      padding-bottom: 1.2rem;
    }
  }

  @media screen and (min-width: ${breakpoints.large}) {
    display: flex;
    ${props => props.isColumnLayout ? 'flex-direction: column;justify-content: space-between;' : 'flex-direction: row;justify-content: flex-start;'}

    & li {
      ${props => !props.isColumnLayout && props.contactCount && `width: calc(100% / ${props.contactCount});border-bottom: 0;`};
    }
  }

  & a {
    display: block;
    font-weight: ${fontWeight.normal};
    font-size: 1.4rem;
    color: ${warmGrey.IX};
  }

  & a[href^='mailto:'] {
    color: ${divisionColors.darker};
  }
`;
const ContactListLabel = styled.span`
  font-size: 1.2rem;
  font-weight: ${fontWeight.bold};
  color: ${warmGrey.IX};
`;

const ContactInformation = ({
  name,
  email,
  telephoneNumber
}) => /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(ContactListLabel, null, name), email && /*#__PURE__*/React.createElement("a", {
  href: `mailto:${email}`,
  "data-email": "true"
}, email), telephoneNumber && /*#__PURE__*/React.createElement("a", {
  href: `tel:${telephoneNumber}`,
  "data-support-number": "true"
}, telephoneNumber));

const UserMenuComponent = styled.div`
  background: ${warmGrey.III};
  position: relative;
  padding: 0;
  -webkit-font-smoothing: antialiased;
`;
const AlertPreferencesLink = styled.a`
  border-top: 0.1rem solid ${warmGrey.IV};
  color: ${divisionColors.darker};
  font-size: 1.4rem;
  margin: 0 1.2rem;
  margin-top: 1rem;
  padding-top: 1rem;
  display: block;
`;
const Label = styled.h2`
  margin: 0 1.2rem;
  font-family: ${fontFamily.primary};
  color: ${warmGrey.IX};
  font-size: 1.2rem;
`;
const Controls = styled.ul`
  display: block;
  width: 100%;
  margin: 0 1.2rem;
  padding: 0.4rem 0 0.8rem;
`;
const Logout = styled.li`
  border-top: 0.1rem solid ${warmGrey.V};
  list-style: none;

  margin: 0;
  width: 100%;
  padding: 1.4rem 0 1.4rem;
  & a {
    margin: 0;
    display: inline;
    color: ${notificationColors.failure};
    font-family: ${fontFamily.primary};
    font-size: 1.4rem;
  }
`;
const UserInfo = styled.section`
  padding: 2rem 0 0;
  @media screen and (min-width: ${breakpoints.large}) {
    display: block;
    width: 100%;
  }
`;
const Username = styled.p`
  margin: 0 1.2rem;
  font-family: ${fontFamily.primary};
  font-size: 1.4rem;
  font-weight: ${fontWeight.normal};
`;
const Section = styled.section`
  ${({
  isColumnLayout
}) => isColumnLayout && `@media screen and (min-width: ${breakpoints.large}) {
     width: 50%;};
  `};
`;
const StyledSectionHeader = styled(TextSectionHeader)`
  margin-bottom: 0;
`;
const StyledSubscriptionsList = styled.ul`
  list-style-type: none;
  margin: 0 1.2rem;
  padding: 0;

  & li {
    color: ${warmGrey.IX};
    border-bottom: 0.1rem solid ${warmGrey.IV};
    font-size: 1.4rem;
    padding: 0.8rem 0;
    &:last-child {
      border-bottom: 0;
      & a {
        padding-bottom: 0;
      }
    }
    & a {
      padding: 0.8rem 0;
      display: block;
    }
  }
`;
const AlertsList = styled(StyledSubscriptionsList)`
  & li {
    color: ${acurisGlobalColors.darker};
    padding: 0;
  }
`;

const ContactsList = ({
  contactList,
  isColumnLayout
}) => /*#__PURE__*/React.createElement(Section, {
  isColumnLayout: isColumnLayout
}, /*#__PURE__*/React.createElement(StyledSectionHeader, {
  text: "Contacts"
}), /*#__PURE__*/React.createElement(StyledContactsList, {
  contactCount: contactList.length,
  isColumnLayout: isColumnLayout
}, contactList.map(contactItem => /*#__PURE__*/React.createElement(ContactInformation, {
  key: contactItem.name,
  name: contactItem.name,
  email: contactItem.email,
  telephoneNumber: contactItem.telephoneNumber
}))));

const OverflowWrapper = styled.div`
  ${({
  subscriptions,
  alertLinks
}) => (subscriptions || alertLinks) && `
    @media screen and (min-width: ${breakpoints.large}) {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }
  `};
`;

function isNotEmptyArray(prop) {
  return Array.isArray(prop) && prop.length > 0;
}

const SubscriptionList = ({
  subscriptions
}) => /*#__PURE__*/React.createElement(Section, {
  isColumnLayout: isNotEmptyArray(subscriptions)
}, /*#__PURE__*/React.createElement(StyledSectionHeader, {
  text: "Subscriptions"
}), /*#__PURE__*/React.createElement(StyledSubscriptionsList, {
  "data-subscription-list": "true"
}, subscriptions.map(subscription => /*#__PURE__*/React.createElement("li", {
  key: subscription,
  "data-subscription-item": "true"
}, subscription))));

function isNotEmptyArray$1(prop) {
  return Array.isArray(prop) && prop.length > 0;
}

const UserMenuAlerts = ({
  alertLinks
}) => /*#__PURE__*/React.createElement(Section, {
  isColumnLayout: isNotEmptyArray$1(alertLinks),
  "data-user-alert-preference-list": "true"
}, /*#__PURE__*/React.createElement(StyledSectionHeader, {
  text: "Alert preferences"
}), /*#__PURE__*/React.createElement(AlertsList, null, alertLinks.map(alert => /*#__PURE__*/React.createElement("li", {
  key: alert.name,
  "data-alert-item": "true"
}, /*#__PURE__*/React.createElement("a", {
  href: alert.link,
  "data-alert-item-link": "true"
}, alert.name)))));

const isNotEmptyArray$2 = prop => Array.isArray(prop) && prop.length > 0;

const UserMenu = ({
  username,
  contactList,
  subscriptions,
  alertLink,
  alertEditionLinks,
  logout
}) => /*#__PURE__*/React.createElement(OverflowWrapper, {
  subscriptions: subscriptions,
  alertLinks: alertEditionLinks
}, /*#__PURE__*/React.createElement(UserInfo, null, /*#__PURE__*/React.createElement(Label, null, "Username"), /*#__PURE__*/React.createElement(Username, {
  "data-username": "true"
}, username), alertLink && /*#__PURE__*/React.createElement(AlertPreferencesLink, {
  "data-test-alert-preference-link": "true",
  href: alertLink
}, "Alert preferences")), alertEditionLinks && /*#__PURE__*/React.createElement(UserMenuAlerts, {
  alertLinks: alertEditionLinks
}), /*#__PURE__*/React.createElement(ContactsList, {
  isColumnLayout: isNotEmptyArray$2(subscriptions) || isNotEmptyArray$2(alertEditionLinks),
  contactList: contactList
}), subscriptions && /*#__PURE__*/React.createElement(SubscriptionList, {
  subscriptions: subscriptions
}), /*#__PURE__*/React.createElement(Controls, null, /*#__PURE__*/React.createElement(Logout, null, /*#__PURE__*/React.createElement("a", {
  href: logout.link,
  onClick: logout.onClick,
  "data-test-logout": "true"
}, "Logout"))));

const StyledHeaderButton = styled.button`
  border-radius: 0.3rem;
  margin: 0;
  width: 2.6rem;
  height: 2.6rem;
  min-height: 2.6rem;
  min-width: 2.6rem;
  padding: 0;
  background: ${warmGrey.I};
  border: 0;
  transition: none;
  outline: 0;
  position: relative;
  z-index: 3;

  ${({
  isSelected
}) => isSelected ? `border: 1px solid ${warmGrey.IV};` : `border: 1px solid transparent;`};

  &:focus,
  &:visited,
  &:active {
    background: ${warmGrey.IV};
  }

  &:hover .icon {
    fill: ${colors.primaryBrandHover};
  }

  &:active {
    border: 1px solid ${warmGrey.IV};
    box-shadow: inset 0 0.2rem 0.3rem 0 ${warmGrey.VII};
    .icon {
      fill: ${colors.primaryBrand};
    }
  }

  @media screen and (min-width: ${breakpoints.xsmall}) {
    width: 3.2rem;
    height: 3.2rem;
  }

  @media screen and (min-width: ${breakpoints.large}) {
    width: 3.6rem;
    height: 3.6rem;
  }

  .icon {
    position: static;
    margin: 0;
    width: 1.6rem;
    height: 1.6rem;
    ${({
  isSelected
}) => isSelected ? `fill: ${colors.primaryBrand};` : `fill: ${warmGrey.VII};`};
  }
`;

const UserMenuButton = ({
  userMenuProps
}) => {
  const {
    activeMenu,
    setElement,
    setContent,
    setActiveMenu
  } = React.useContext(FocusContext);
  const button = React.createRef();
  const isSelected = activeMenu === 'user';
  return /*#__PURE__*/React.createElement(StyledHeaderButton, {
    "data-test-usermenu-button": "true",
    ref: button,
    onClick: () => {
      setElement(button.current);
      setContent(!isSelected ? /*#__PURE__*/React.createElement(UserMenu, userMenuProps) : null);
      setActiveMenu(!isSelected ? 'user' : null);
    },
    isSelected: isSelected
  }, /*#__PURE__*/React.createElement(UserIcon, {
    title: "personalise"
  }), /*#__PURE__*/React.createElement("span", {
    className: "visuallyhidden"
  }, "User Profile"));
};

export { ContactInformation, ContactsList, StyledHeaderButton as HeaderButton, SubscriptionList, UserMenu, UserMenuAlerts, UserMenuButton };
//# sourceMappingURL=index.js.map
